// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4463":"cb961fea","7069":"bc6f5317","7315":"bc6f5317","9945":"bc6f5317"}[chunkId] + ".chunk.css";
};